import { useSuspenseQuery } from "@tanstack/react-query"

import { getUsage } from "../../app/services/usage"

type UseUsageQueryArgs =
  | { startDate: Date; endDate: Date }
  | { startDate?: undefined; endDate?: undefined }

export function useUsageQuery(args: UseUsageQueryArgs) {
  const { startDate, endDate } = args

  return useSuspenseQuery({
    queryKey: ["usage", startDate, endDate],
    queryFn: () =>
      startDate ? getUsage({ startDate, endDate }) : Promise.reject(),
  })
}
